/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from "react";
import { Horario24 } from "../../../../utils/Horario24";

const Horarios = ({ setForm, form }: any) => {
  const [checkin, setCheckin] = useState({
    id: null,
    //--'flexible'--
    name: "Sin finalizacion",
    time: "12:00",
    porperty_id: null,
    created_at: "",
  });



  const onChange = (e: any) => {
    switch (e.target.name) {
      case "checkin-time":
        {
          let id = form.CHECKIN?.length > 0 ? form.CHECKIN[0].id : null;
          let setCheckin_ : any = {
            ...checkin,
            id: id,
            time: e.target.value,
          }
          setCheckin({
            ...checkin,
            id: id,
            time: e.target.value,
          });
          setForm({
            ...form,
            CHECKIN: setCheckin_,
          });
        }
        break;
      case "checkin-finalizacion":
        {
          let id = form.CHECKIN.length > 0 ? form.CHECKIN[0].id : null;
          let setCheckin_ : any = {
            ...checkin,
            id: id,
            name: e.target.value,
          }
          setForm({
            ...form,
            CHECKIN: setCheckin_,
          });
        }
        break;
      case "checkout-time":
        {
          let id = form.CHECKOUT? form.CHECKOUT.id : null;
          let setCheckout_ : any = {
            id: id,
            time: e.target.value,
          }
          setForm({
            ...form,
            CHECKOUT: setCheckout_,
          });
        }
        break;
      case "max_nights":
      case "min_nights":
        {
          setForm({
            ...form,
            [e.target.name]: e.target.value,
          });
        }
        break;
      default:
        break;
    }
  };

  return (
    <div className="grid lg:grid-cols-1 gap-10 py-5 px-5">
      <div>
        <span className="font-bold text-black mb-2 block">
          Especifícanos los horarios
        </span>
        <div className="grid grid-cols-1 gap-5">
          <span>
            Podés agregar más servicios después de publicar el anuncio.
          </span>

          <div className="border px-5 py-3 shadow-xl border-black rounded-xl">
            <span>Horario para el Check-In</span>

            <div className="relative">
              <div
                className="absolute inset-y-0 start-0 top-[-30px]  flex items-center ps-3 pointer-events-none font-bolder"
                style={{ fontSize: "10px" }}
              >
                Hora de inicio
              </div>
              <select
                className="pt-5 w-full"
                style={{ borderRadius: "10px 10px 0px 0px" }}
                name="checkin-time"
                onChange={(event) => onChange(event)}
              >
                <option selected>{form.CHECKIN?.time}</option>
                {Horario24().map((h) => (
                  <option value={h}>{h}</option>
                ))}
              </select>
            </div>
            <div className="relative">
              <div
                className="absolute inset-y-0 start-0 top-[-30px]  flex items-center ps-3 pointer-events-none font-bolder"
                style={{ fontSize: "10px" }}
              >
                Hora de finalización
              </div>
              <select
                className="pt-5 w-full"
                style={{ borderRadius: "0px 0px 10px 10px" }}
                name="checkin-finalizacion"
                onChange={(event) => onChange(event)}
              >
                <option value="Sin finalizacion">Sin finalizacion</option>
                <option value="Flexible">Flexible</option>
              </select>
            </div>

          </div>

          <div className="border px-5 py-3 shadow-xl border-black rounded-xl">
            <span>Horario para el Check-Out</span>

            <div className="relative">
              <div
                className="absolute inset-y-0 start-0 top-[-30px]  flex items-center ps-3 pointer-events-none font-bolder"
                style={{ fontSize: "10px" }}
              >
                Hora
              </div>
              <select
                id="countries"
                className="pt-5 w-full"
                style={{ borderRadius: "10px 10px 0px 0px" }}
                name="checkout-time"
                onChange={(event) => onChange(event)}
              >
                <option selected>{form.CHECKOUT?.time}</option>
                {Horario24().map((h) => (
                  <option value={h}>{h}</option>
                ))}
              </select>
            </div>

          </div>

          <div className="border px-5 py-3 shadow-xl border border-black rounded-xl">
            <span>Duración del viaje</span>

            <div className="relative">
              <div
                className="absolute inset-y-0 start-0 top-[-30px]  flex items-center ps-3 pointer-events-none font-bolder"
                style={{ fontSize: "10px" }}
              >
                Cantidad mínima de noches
              </div>
              <select
                id="countries"
                className="pt-5 w-full"
                style={{ borderRadius: "10px 10px 0px 0px" }}
                name="min_nights"
                onChange={(event) => onChange(event)}
              >
                {[2, 3, 4, 5, 6, 7, 8, 9, 10].map((n) => (
                  <option value={n}>{n}</option>
                ))}
              </select>
            </div>
            <div className="relative">
              <div
                className="absolute inset-y-0 start-0 top-[-30px]  flex items-center ps-3 pointer-events-none font-bolder"
                style={{ fontSize: "10px" }}
              >
                Número máximo de noches
              </div>
              <select
                id="countries"
                className="pt-5 w-full"
                style={{ borderRadius: "0px 0px 10px 10px" }}
                name="max_nights"
                onChange={(event) => onChange(event)}
              >
                {[100, 200, 300, 460].map((n) => (
                  <option value={n}>{n}</option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>
      <div></div>
    </div>
  );
};

export default Horarios;
